/**
 * An address that does not resolve.
 *
 * Most arrivals here are a bookmark to a legacy URL or a report that has not been ported, so the
 * page says where to look rather than only that something is missing (§4.10).
 */

import { faCompass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useLocation } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { useI18n } from '@/lib/i18n';

export default function NotFoundPage() {
  const { text } = useI18n();
  const { pathname } = useLocation();

  return (
    <div className="mx-auto w-full max-w-md space-y-6 py-16 text-center">
      <FontAwesomeIcon icon={faCompass} className="text-3xl text-muted-foreground" aria-hidden />

      <div className="space-y-2">
        <h1 className="text-xl font-semibold tracking-tight">{text('There is no page at this address')}</h1>
        <p className="text-sm text-muted-foreground">
          <span className="font-mono break-all">{pathname}</span> does not match a report. If you
          followed a link from the old Win Dashboard, the report may not be ported yet — check the
          menu under its operation.
        </p>
      </div>

      <Button asChild>
        <Link to="/">{text('Go to overview')}</Link>
      </Button>
    </div>
  );
}
